import { memo } from 'react';

function LeftSideLayout2() {
	return null;
}

export default memo(LeftSideLayout2);
